import { useEffect, useState } from "react";
import { MdDirectionsCar, MdMyLocation, MdLocationOff } from "react-icons/md";
import { useUserLocation } from "./UserLocation";
import { geocodeAddress, getDrivingRoute } from "./geoapi";

function formatDuration(seconds) {
  if (seconds == null) return null;
  const mins = Math.round(seconds / 60);
  if (mins < 60) return `${mins} min`;
  const hrs = Math.floor(mins / 60);
  const remMins = mins % 60;
  return remMins > 0 ? `${hrs}h ${remMins}m` : `${hrs}h`;
}

function formatDistance(meters) {
  if (meters == null) return null;
  const km = meters / 1000;
  return km < 1 ? `${Math.round(meters)} m` : `${km.toFixed(1)} km`;
}

function JobDistance({ state, localGovernment, city }) {
  const { location: userLocation, status, error: locError, requestLocation } = useUserLocation();

  const [routeInfo, setRouteInfo] = useState(null);
  const [loadingRoute, setLoadingRoute] = useState(false);
  const [routeError, setRouteError] = useState(null);

  useEffect(() => {
    console.log("[JobDistance] user location status:", status, userLocation, locError);
    let cancelled = false;

    async function computeDistance() {
      // Need a granted location and a state to compare against — bail early otherwise.
      if (status !== "granted" || !userLocation || !state) return;

      setLoadingRoute(true);
      setRouteError(null);
      setRouteInfo(null);

      console.log("[JobDistance] geocoding:", state, localGovernment);
      const employerCoords = await geocodeAddress(state, localGovernment);
      console.log("[JobDistance] employerCoords:", employerCoords);

      if (cancelled) return;

      if (!employerCoords) {
        setRouteError("Location unavailable for this job");
        setLoadingRoute(false);
        return;
      }

      const route = await getDrivingRoute(userLocation, employerCoords);
      console.log("[JobDistance] route:", route);

      if (cancelled) return;

      if (route) {
        setRouteInfo(route);
      } else {
        setRouteError("Route unavailable");
      }
      setLoadingRoute(false);
    }

    computeDistance();
    return () => { cancelled = true; };
  }, [status, userLocation, state, localGovernment, city]);

  return (
    <div className="text-xs border border-dashed border-orange-300 p-2 rounded bg-orange-50">
      {/* <div>status: <b>{status}</b></div> */}
      {locError && <div>location error: {locError}</div>}
      {loadingRoute && <div>loading route...</div>}
      {routeError && <div>route error: {routeError}</div>}
      {routeInfo && (
        <div>
          <MdDirectionsCar className="inline mr-1" />
          {routeInfo.distanceText ?? formatDistance(routeInfo.distanceMeters)}
          {" · "}
          {routeInfo.durationText ?? formatDuration(routeInfo.durationSeconds)}
        </div>
      )}
      {status === "denied" && (
        <button onClick={requestLocation} className="text-orange-600 underline">
          retry location
        </button>
      )}
    </div>
  );
}

export default JobDistance;